module.exports = __webpack_public_path__ + "img/riskimage.117a7f37.png";